import React from 'react';
import PhoneIcon from '@mui/icons-material/Phone';
import PlaceIcon from '@mui/icons-material/Place';
import {
  AI_COLORS, AI_FONTS,
  PageHero, ContentWrap, SectionTitle,
} from '../shared';

const unidades = [
  {
    nome: 'Hospital Odontológico da UFU (HOUFU)',
    endereco:
      'Bloco 4L Anexo B Térreo, R. República do Piratini, 1229-1101 — Umuarama, Uberlândia - MG, 38405-266',
    telefone: '(34) 3225-8108',
    mapa:
      'https://maps.google.com/maps?q=R.+Rep%C3%BAblica+do+Piratini%2C+1229-1101+-+Umuarama%2C+Uberl%C3%A2ndia+-+MG%2C+38405-266&output=embed',
  },
  {
    nome: 'Pronto Socorro Odontológico (PSO)',
    endereco: '4A — Umuarama, Uberlândia - MG, 38402-293 (atendimento 24h, todos os dias)',
    telefone: '(34) 3225-8151',
    mapa: 'https://maps.google.com/maps?q=Pronto+Socorro+Odontol%C3%B3gico+-+4A+-+Umuarama&output=embed',
  },
];

export default function FaleConosco() {
  return (
    <div style={{ fontFamily: AI_FONTS.body, background: 'transparent' }}>
      <PageHero
        title="Fale Conosco"
        subtitle="Precisa de atendimento ou quer tirar dúvidas? Veja abaixo nossas unidades, telefones e localização."
      />

      <ContentWrap>
        <SectionTitle style={{ marginTop: 0 }}>Nossas unidades</SectionTitle>

        <div style={{ display: 'grid', gap: 24 }}>
          {unidades.map((u, i) => (
            <div
              key={i}
              style={{
                background: i % 2 === 0 ? AI_COLORS.bgBlue50 : AI_COLORS.bgPurple50,
                borderRadius: 16,
                padding: '22px 24px',
              }}
            >
              <h3
                style={{
                  fontFamily: AI_FONTS.title,
                  color: AI_COLORS.blue900,
                  fontSize: '1.2rem',
                  marginTop: 0,
                  marginBottom: 12,
                }}
              >
                {u.nome}
              </h3>
              <p style={{ display: 'flex', gap: 8, alignItems: 'flex-start', lineHeight: 1.6 }}>
                <PlaceIcon style={{ color: AI_COLORS.blue800, fontSize: 20, flexShrink: 0 }} />
                {u.endereco}
              </p>
              <p style={{ display: 'flex', gap: 8, alignItems: 'center', lineHeight: 1.6 }}>
                <PhoneIcon style={{ color: AI_COLORS.blue800, fontSize: 20, flexShrink: 0 }} />
                <strong>{u.telefone}</strong>
              </p>
              <iframe
                title={u.nome}
                src={u.mapa}
                style={{
                  width: '100%',
                  height: 240,
                  border: 'none',
                  borderRadius: 12,
                  marginTop: 8,
                }}
              />
            </div>
          ))}
        </div>
      </ContentWrap>
    </div>
  );
}
